// extracted by mini-css-extract-plugin
module.exports = {"quicklinks":"styles_quicklinks__Dqng7","rotate":"styles_rotate__SKCzZ","rotate-reverse":"styles_rotate-reverse__z_uIu"};